// states/newsState.js
import { useState } from "react";

export const useNewsState = () => {
  const [newsData, setNewsData] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedNews, setSelectedNews] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return {
    newsData,
    setNewsData,
    filteredNews,
    setFilteredNews,
    loading,
    setLoading,
    activeCategory,
    setActiveCategory,
    selectedNews,
    setSelectedNews,
    isModalOpen,
    setIsModalOpen
  };
};